module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/25365a729d97c1ef1cdd81e120e0fbf3.png";